import * as WriteStateSlice from '../../../common/state/WriteStateSlice';

export type State = WriteStateSlice.State;

export class StateSlice extends WriteStateSlice.StateSlice {
    key(): string {
        return 'account-current-login-EditResponse';
    }
}
